import { render, staticRenderFns } from "./PromotionsGrid.vue?vue&type=template&id=ea6f3aa0&scoped=true&"
import script from "./PromotionsGrid.vue?vue&type=script&lang=ts&"
export * from "./PromotionsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsGrid.vue?vue&type=style&index=0&id=ea6f3aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6f3aa0",
  null
  
)

export default component.exports